// Adapted from https://www.emgoto.com/react-table-of-contents/
import { useRef, useEffect } from 'react'

import routes from './routes'

export default function useIntersectionObserver(setActiveId) {
  const sectionsRef = useRef({})

  useEffect(() => {
    const callback = (sections) => {
      sectionsRef.current = sections.reduce((allSections, headingElement) => {
        allSections[headingElement.target.id] = headingElement
        return allSections
      }, sectionsRef.current)

      const visibleSections = []
      Object.keys(sectionsRef.current).forEach((key) => {
        const sectionElement = sectionsRef.current[key]
        if (sectionElement.isIntersecting) {
          visibleSections.push(sectionElement)
        }
      })

      const getIndexFromId = (id) =>
        sections.findIndex((section) => section.id === id)

      if (visibleSections.length === 1) {
        setActiveId(visibleSections[0].target.id)
      } else if (visibleSections.length > 1) {
        const sortedVisibleSections = visibleSections.sort(
          (a, b) => getIndexFromId(a.target.id) > getIndexFromId(b.target.id)
        )
        setActiveId(sortedVisibleSections[0].target.id)
      }
    }

    const observer = new IntersectionObserver(callback, {
      rootMargin: '-110px 0px -40% 0px',
    })

    const sections = Object.values(routes).map((route) =>
      document.getElementById(route.id)
    )
    sections.forEach((section) => section && observer.observe(section))

    return () => {
      observer.disconnect()
      sectionsRef.current = {}
    }
  }, [])
}
